export default {
  "app": {
    "name": "DeepTrade",
    "tagline": "AI 기반 암호화폐 거래",
    "description": "고급 거래 신호 및 자동화된 포트폴리오 관리",
  },
  "navigation": {
    "dashboard": "대시보드",
    "trading": "거래",
    "signals": "신호",
    "apiCredentials": "API 자격증명",
    "autoTrading": "자동 거래",
    "tierManagement": "티어 관리",
    "referrals": "추천",
    "accessSecurity": "접근 및 보안",
    "settings": "설정",
    "help": "도움말 및 지원",
    "login": "로그인",
    "register": "회원가입",
    "logout": "로그아웃",
    "home": "홈",
  },
  "auth": {
    "layout": {
      "signInToAccount": "계정에 로그인하세요",
      "or": "또는",
      "createNewAccount": "새 계정 만들기"
    },
    "login": {
      "title": "다시 오신 것을 환영합니다",
      "subtitle": "이메일과 비밀번호를 입력하여 로그인하세요",
      "email": "이메일",
      "password": "비밀번호",
      "emailPlaceholder": "name@example.com",
      "passwordPlaceholder": "••••••••",
      "rememberMe": "로그인 상태 유지",
      "forgotPassword": "비밀번호를 잊으셨나요?",
      "signIn": "로그인",
      "noAccount": "계정이 없으신가요?",
      "signUp": "가입하기",
      "googleSignIn": "Google로 계속하기",
      "orContinueWith": "또는 다음으로 계속",
      "fillAllFields": "모든 필드를 입력해주세요",
      "loginSuccess": "로그인에 성공했습니다!",
      "loginFailed": "로그인에 실패했습니다",
      "loginFailedDescription": "로그인에 실패했습니다",
      "googleLoginFailed": "Google 로그인 시작에 실패했습니다",
      "bySigningIn": "로그인하면 다음에 동의하는 것입니다",
      "termsOfService": "서비스 약관",
      "privacyPolicy": "개인정보 보호정책",
      "and": "및"
    },
    "register": {
      "title": "계정 생성",
      "subtitle": "계정을 생성하기 위해 정보를 입력하세요",
      "firstName": "이름",
      "lastName": "성",
      "email": "이메일",
      "password": "비밀번호",
      "confirmPassword": "비밀번호 확인",
      "agreeTerms": "계속하기를 클릭하면 다음에 동의하는 것입니다",
      "createAccount": "계정 생성",
      "hasAccount": "이미 계정이 있으신가요?",
      "signIn": "로그인",
      "orContinueWith": "또는 다음으로 계속",
      "googleSignUp": "Google로 가입하기",
      "termsOfService": "서비스 약관",
      "privacyPolicy": "개인정보 보호정책",
      "referralCode": "추천 코드 (선택사항)",
      "placeholders": {
        "firstName": "홍",
        "lastName": "길동",
        "email": "이름@예시.com",
        "password": "비밀번호를 입력하세요",
        "confirmPassword": "비밀번호를 확인하세요",
        "referralCode": "추천 코드를 입력하세요"
      },
      "validation": {
        "minLength": "비밀번호는 최소 8자 이상이어야 합니다",
        "uppercase": "비밀번호는 최소 하나의 대문자를 포함해야 합니다",
        "lowercase": "비밀번호는 최소 하나의 소문자를 포함해야 합니다",
        "number": "비밀번호는 최소 하나의 숫자를 포함해야 합니다",
        "specialChar": "비밀번호는 최소 하나의 특수문자를 포함해야 합니다"
      },
      "errors": {
        "invalidReferralCode": "유효하지 않은 추천 코드",
        "referralValidationFailed": "추천 코드를 검증할 수 없습니다. 연결을 확인하고 다시 시도해 주세요.",
        "googleLoginFailed": "Google 로그인 실패",
        "googleLoginFailedTitle": "Google 로그인 실패",
        "fillAllFields": "모든 필드를 입력해 주세요",
        "requirementsNotMet": "비밀번호 요구사항이 충족되지 않았습니다",
        "passwordsDoNotMatch": "비밀번호가 일치하지 않습니다",
        "registrationFailed": "회원가입 실패",
        "failedToCreateAccount": "계정 생성 실패",
        "emailAlreadyRegistered": "이미 등록된 이메일",
        "emailAlreadyRegisteredDescription": "이 이메일 주소로 이미 계정이 존재합니다. 로그인을 시도해 주세요.",
        "connectionError": "연결 오류",
        "connectionErrorDescription": "서버에 연결할 수 없습니다. 인터넷 연결을 확인하고 다시 시도해 주세요.",
        "referralCodeError": "추천 코드 오류",
        "referralCodeErrorDescription": "추천 코드 처리 중 문제가 발생했습니다. 계정은 여전히 생성됩니다.",
        "failedToResendEmail": "인증 이메일 재전송 실패",
        "failedToResendEmailTitle": "이메일 재전송 실패",
        "tryAgainLater": "나중에 다시 시도해 주세요."
      },
      "success": {
        "title": "회원가입 성공!",
        "description": "계정을 인증하기 위해 이메일을 확인해 주세요."
      },
      "verification": {
        "title": "이메일 확인",
        "description": "{{email}}로 인증 링크를 보냈습니다",
        "nextSteps": "다음 단계:",
        "step1": "1. 이메일 받은편지함 확인",
        "step2": "2. 인증 링크 클릭",
        "step3": "3. 여기로 돌아와서 로그인",
        "sending": "전송 중...",
        "resendButton": "인증 이메일 재전송",
        "backToLogin": "로그인으로 돌아가기",
        "emailSentTitle": "인증 이메일 전송됨",
        "emailSentDescription": "인증 링크를 위해 이메일을 확인해 주세요."
      },
      "referral": {
        "validating": "추천 코드 검증 중...",
        "validCode": "{{referrer}}의 유효한 추천 코드"
      }
    },
    "passwordRequirements": {
      "title": "비밀번호 요구사항",
      "length": "최소 8자",
      "uppercase": "대문자 하나",
      "lowercase": "소문자 하나",
      "number": "숫자 하나",
      "special": "특수문자 하나",
    },
    "errors": {
      "invalidCredentials": "잘못된 이메일 또는 비밀번호",
      "emailRequired": "이메일이 필요합니다",
      "passwordRequired": "비밀번호가 필요합니다",
      "passwordTooShort": "비밀번호는 최소 8자 이상이어야 합니다",
      "passwordsNotMatch": "비밀번호가 일치하지 않습니다",
      "emailInvalid": "유효한 이메일 주소를 입력해주세요",
      "termsRequired": "이용약관에 동의해야 합니다",
    }
  },
  "dashboard": {
    "title": "대시보드",
    "welcome": "다시 오신 것을 환영합니다!",
    "overview": "개요",
    "trading": "거래",
    "tier": "등급",
    "balance": "잔액",
    "pnlToday": "손익",
    "totalTrades": "총 거래",
    "winRate": "승률",
    "activeSignals": "활성 신호",
    "tradingOverview": "거래 개요",
    "quickActions": "빠른 작업",
    "viewSignals": "신호 보기",
    "autoTrading": "자동 거래",
    "autoTradingDescription": "거래 신호를 자동으로 실행",
    "currentTier": "현재 등급",
    "progressTo": "{{tier}} 등급으로 진행",
    "yourBenefits": "혜택",
    "advancedSignals": "고급 거래 신호",
    "autoTradingFeatures": "자동 거래 기능",
    "prioritySupport": "우선 지원",
    "monthlyRate": "월간 수익률",
    "profitShare40": "40% 수익 분배",
    "profitShare20": "20% 수익 분배",
    "profitShare10": "10% 수익 분배",
    "verifyingNFT": "NFT 소유권 확인 중...",
    "debt": "부채",
    "btcPrice": {
      "symbol": "BTC/USDT",
      "loading": "BTC/USDT: 로딩 중...",
      "unavailable": "BTC/USDT: --",
      "connecting": "연결 중...",
      "live": "실시간",
      "error": "오류 ({{count}})",
      "24h": "24시간",
    },
    "controls": {
      "turnOn": "켜기",
      "turnOff": "끄기",
      "paperAutoTrading": "페이퍼 자동 거래",
    },
    "forecast": {
      "title": "가격 예측",
      "refresh": "새로고침",
      "errorLoading": "차트를 불러오는 중 오류",
      "retry": "다시 시도",
      "noData": "사용 가능한 차트 데이터가 없습니다",
    },
    "tradingChart": {
      "forecast": "예측",
      "upperBound": "상한",
      "lowerBound": "하한",
      "support": "지지",
      "resistance": "저항",
      "entry": "진입",
      "stopLoss": "손절",
      "takeProfit": "익절",
      "partialTakeProfit": "부분 익절",
      "liquidation": "청산",
      "locked": "잠김",
      "positionLevelDialogTitle": "{{level}} 업데이트 확인",
      "positionLevelDialogDescription": "{{symbol}} {{side}}의 {{level}}을(를) {{currentPrice}}에서 {{newPrice}}(으)로 설정할까요?",
      "positionLevelDelta": "변경: {{delta}}%",
      "positionLevelConfirm": "{{level}} 업데이트",
      "positionLevelCancel": "취소",
      "positionLevelProcessing": "업데이트 중...",
      "positionLevelSuccess": "{{level}}이(가) 업데이트되었습니다",
      "positionLevelSuccessDesc": "{{symbol}} {{side}} · 새 {{level}}: {{price}}",
      "positionLevelFailure": "{{level}} 업데이트 실패",
      "positionLevelFailureDesc": "이전 레벨이 복원되었습니다. {{error}}",
      "dragHint": "드래그하여 이동 · 놓아서 확인",
      "indicators": {
        "title": "지표",
        "overlays": "오버레이",
        "panes": "패널",
        "levels": "레벨",
        "keyLevels": "핵심 레벨 (S/R)",
        "reset": "지표 초기화",
        "ema20": "EMA 20",
        "ema50": "EMA 50",
        "ema200": "EMA 200",
        "sma20": "SMA 20",
        "sma50": "SMA 50",
        "bb20": "볼린저 밴드 (20, 2)",
        "bbUpper": "볼린저 상단",
        "bbMiddle": "볼린저 중간",
        "bbLower": "볼린저 하단",
        "vwap": "VWAP",
        "rsi14": "RSI (14)",
        "macd": "MACD (12, 26, 9)",
        "macdSignal": "MACD 시그널",
      },
      "drawing": {
        "toolbar": "그리기 도구",
        "select": "선택",
        "magnetMode": "자석: {{mode}}",
        "stayInDrawingMode": "그리기 모드 유지",
        "hideAll": "모든 그림 숨기기",
        "showAll": "모든 그림 표시",
        "undo": "실행 취소",
        "redo": "다시 실행",
        "deleteSelected": "선택한 그림 삭제",
        "clearAll": "모든 그림 지우기",
        "moreTools": "더 많은 그리기 도구",
        "export": "그림 내보내기",
        "import": "그림 가져오기",
        "textPrompt": "그림 텍스트 입력",
        "loadFailure": "그리기 도구를 사용할 수 없습니다",
        "importEmpty": "이 파일에서 그림을 찾을 수 없습니다",
        "importSuccess": "{{count}}개의 그림을 가져왔습니다",
        "importFailure": "그림을 가져오지 못했습니다",
        "clearConfirmTitle": "모든 그림을 지우시겠습니까?",
        "clearConfirmDescription": "현재 심볼과 시간대의 모든 그림을 삭제합니다. 이 작업은 되돌릴 수 없습니다.",
        "categories": {
          "lines": "선",
          "channels": "채널",
          "fibonacci": "피보나치 및 간",
          "patterns": "패턴",
          "elliott": "엘리엇",
          "forecasting": "예측 및 측정",
          "volume": "거래량",
          "annotations": "주석",
          "shapes": "도형",
          "cycles": "주기",
          "regression": "회귀",
        },
        "tools": {
          "trend-line": "추세선",
          "horizontal-line": "수평선",
          "vertical-line": "수직선",
          "ray": "광선",
          "parallel-channel": "평행 채널",
          "fib-retracement": "피보나치 되돌림",
          "trend-based-fib-extension": "추세 기반 피보나치 확장",
          "rectangle": "사각형",
          "text": "텍스트",
          "arrow": "화살표",
          "brush": "브러시",
          "price-range": "가격 범위",
          "long-position": "롱 포지션",
          "short-position": "숏 포지션",
        },
      },
    },
    "realTimePerformance": "실시간 성과",
    "riskSettings": {
      "title": "위험 관리 설정",
      "paperTradingTitle": "위험 관리 설정 - 모의 거래",
      "loading": "위험 설정 로딩 중...",
      "investmentPercentage": "투자 비율",
      "investmentDescription": "거래에 사용할 잔액 비율 (0% - 10%)",
      "leverage": "레버리지",
      "leverageDescription": "최대: {{tier}} 등급 + {{exchange}} {{market}}에서 {{max}}x",
      "paperTradingLeverageDesc": "모의 모드에서는 테스트 목적으로 모든 레버리지 설정을 사용할 수 있습니다",
      "exchange": "거래소: ",
      "configureCredentials": "API 자격 증명에서 구성",
      "warningZeroInvestment": "거래를 활성화하려면 투자 비율 > 0%를 선택하세요",
      "paperTradingNote": "모의 거래 모드 - 등급 제한이 적용되지 않습니다",
      "saveSettings": "설정 저장",
      "saving": "저장 중...",
      "resetToSafe": "안전 모드로 재설정",
      "confirmSaveTitle": "위험 설정 확인",
      "confirmSaveDesc": "이 위험 설정을 저장하시겠습니까?\n\n투자: {{investment}}%\n레버리지: {{leverage}}x\n모드: {{mode}}",
      "confirmSave": "설정 저장",
      "saveSuccess": "설정 저장됨",
      "saveSuccessDesc": "위험 관리 설정이 성공적으로 저장되었습니다.",
      "saveError": "저장 실패",
      "tradingStrategy": "거래 전략",
      "strategyActive": "표준 전략",
      "strategyConservative": "뉴럴 AI 전략",
      "strategyActiveBadge": "추천",
      "strategyActiveDesc": "ML 가격 예측을 기반으로 한 더 빈번한 거래. 하루 3~8개의 신호를 생성하며 예상 정확도는 75~80%입니다. 더 많은 기회를 원하면서도 중간 수준의 활동을 감당할 수 있는 트레이더에게 적합합니다.",
      "strategyConservativeDesc": "엄격한 확인을 거친 고신뢰 거래. 하루 1~3개의 신호를 생성하며 예상 정확도는 85~90%입니다. 수량보다 품질을 중시하는 보수적 트레이더에게 적합합니다.",
      "gridTradingTitle": "Grid Trading",
      "gridEnabledLabel": "Grid Trading 활성화",
      "trailingStopTitle": "Trailing Stop",
      "trailingStopEnabledLabel": "Trailing Stop 활성화",
      "signalsPerDay": "일일 신호 수",
      "expectedAccuracy": "예상 정확도",
      "tradeFrequency": "거래 빈도",
      "riskLevel": "위험 수준",
      "profitPotential": "수익 잠재력",
      "bestFor": "최적 대상",
      "activeTraders": "더 많은 기회를 원하는 적극적인 트레이더",
      "conservativeTraders": "양보다 질을 선호하는 보수적인 트레이더",
      "high": "높음",
      "low": "낮음",
      "moderate": "보통",
      "higher": "더 높음",
      "viewComparison": "비교 보기",
      "hideComparison": "비교 숨기기",
      "testForecastStrategy": "예측 전략 테스트",
      "testingStrategy": "전략 테스트 중...",
      "testStrategyDesc": "예측 전략이 지금 거래를 열지 테스트하려면 클릭하세요",
      "paperSettingsError": "페이퍼 설정 오류",
      "paperSettingsErrorDesc": "페이퍼 거래 위험 설정을 로드하는데 실패했습니다.",
      "settingsLoadError": "설정 로드 오류",
      "settingsLoadErrorDesc": "위험 설정을 로드하는데 실패했습니다. 페이지를 새로고침해주세요.",
      "configurationRequired": "구성 필요",
      "configurationRequiredDesc": "전략을 테스트하기 전에 투자 비율을 0% 이상으로 설정해주세요.",
      "noTradeSignal": "거래 신호 없음",
      "noTradeSignalDesc": "예측에서 불충분한 움직임을 보여줍니다. 상승: {{upward}}%, 하락: {{downward}}%. 거래를 트리거하려면 >0.5%가 필요합니다.",
      "strategyTestSuccessful": "전략 테스트 성공",
      "strategyTestSuccessfulDesc": "{{direction}} 신호가 {{movement}}% 잠재적 움직임으로 감지되었습니다. {{result}}",
      "paperTradeOpened": "페이퍼 거래가 성공적으로 열렸습니다!",
      "tradeSimulationCompleted": "거래 시뮬레이션이 완료되었습니다.",
      "strategyTestFailed": "전략 테스트 실패",
      "strategyTestFailedDesc": "전략 테스트 중 알 수 없는 오류가 발생했습니다.",
      "strategyTestError": "전략 테스트 오류",
      "strategyTestErrorDesc": "예측 전략을 테스트하는데 실패했습니다.",
    },
    "activePositions": {
      "title": "활성 포지션",
      "tabs": {
        "all": "전체",
        "app": "앱",
        "external": "외부",
      },
      "refresh": "새로고침",
      "errorLoading": "활성 포지션 로딩 오류",
      "retry": "다시 시도",
      "noPositions": "활성 포지션이 없습니다.",
      "noPositionsDesc": "거래를 시작하거나 자동 거래를 활성화하면 활성 거래 포지션이 여기에 표시됩니다.",
      "noAppPositions": "활성 앱 포지션이 없습니다.",
      "noExternalPositions": "활성 외부 포지션이 없습니다.",
      "addCredentialsWarning": " 외부 포지션을 보려면 API 자격 증명을 추가하세요",
      "externalError": "❌ 외부 포지션 오류: {{error},",
      "externalErrorGeneric": "❌ {{error},",
      "diagnostics": "앱: {{app}} | 외부: {{external},",
      "fields": {
        "size": "크기",
        "entryPrice": "진입 가격",
        "currentPrice": "현재 가격",
        "margin": "마진",
        "liquidationPrice": "청산 가격",
        "marginRate": "마진 비율",
        "takeProfit": "익절",
        "stopLoss": "손절",
        "roe": "ROE",
        "none": "없음",
        "na": "N/A",
      },
      "positionTypes": {
        "appPositions": "앱 포지션",
        "externalPositions": "외부 포지션",
      },
      "headers": {
        "symbol": "심볼",
        "size": "크기",
        "entryPrice": "진입 가격",
        "markPrice": "마크 가격",
        "liqPrice": "청산 가격",
        "margin": "마진",
        "pnlRoi": "PNL (ROE %)",
        "tpSl": "TP/SL",
        "actions": "액션",
      },
      "close": "닫기",
      "closing": "닫는 중...",
      "featureNotAvailable": "기능 사용 불가",
      "positionClosingPaperOnly": "포지션 닫기는 현재 페이퍼 거래 모드에서만 사용할 수 있습니다.",
      "tpSlPaperOnly": "TP/SL은 현재 페이퍼 거래 모드에서만 사용할 수 있습니다.",
      "positionClosed": "포지션 닫힘",
      "positionClosedDesc": "포지션이 성공적으로 닫혔습니다. PnL: ${{pnl}}",
      "errorClosingPosition": "포지션 닫기 오류",
      "errorClosingPositionDesc": "포지션을 닫는데 실패했습니다",
      "takeProfitSet": "익절 설정됨",
      "takeProfitSetDesc": "익절이 ${{price}}에 설정되었습니다",
      "errorSettingTakeProfit": "익절 설정 오류",
      "errorSettingTakeProfitDesc": "익절 설정에 실패했습니다",
      "stopLossSet": "손절 설정됨",
      "stopLossSetDesc": "손절이 ${{price}}에 설정되었습니다",
      "errorSettingStopLoss": "손절 설정 오류",
      "errorSettingStopLossDesc": "손절 설정에 실패했습니다",
      "position": "포지션",
      "positions": "포지션들",
      "allPositions": "모든 포지션",
      "noApiCredentials": "연결된 API 자격 증명 없음",
    },
    "debug": {
      "testSuccessful": "디버그 거래 테스트 성공",
      "paperTradeOpened": "페이퍼 거래가 성공적으로 열렸습니다!",
      "tradeSimulationCompleted": "거래 시뮬레이션이 완료되었습니다.",
      "testFailed": "디버그 거래 테스트 실패",
      "unknownError": "디버그 거래 테스트 중 알 수 없는 오류가 발생했습니다.",
      "testError": "디버그 테스트 오류",
      "testErrorDesc": "거래 개시 테스트에 실패했습니다.",
    },
    "profitShare": {
      "title": "수익 분배 추적",
      "loading": "수익 분배 데이터 로딩 중...",
      "noData": "사용 가능한 수익 분배 데이터가 없습니다. 거래를 시작하여 수익을 추적하세요.",
      "balanceOverview": "잔액 개요",
      "initialBalance": "초기 잔액:",
      "currentBalance": "현재 잔액:",
      "netDeposits": "순 입금:",
      "profitAnalysis": "수익 분석",
      "tradingProfit": "거래 수익:",
      "trueProfit": "실제 수익:",
      "profitPercentage": "수익률:",
      "profitShareInfo": "수익 분배",
      "tierRate": "{{tier}} 등급 비율:",
      "amountOwed": "지불해야 할 금액:",
      "status": "상태:",
      "profitable": "계정이 수익 상태입니다 - 수익 분배는 초기 잔액을 초과하는 이익에 적용됩니다",
      "notProfitable": "계정이 아직 수익성이 없습니다 - 잔액이 초기 + 입금을 초과할 때까지 수익 분배가 없습니다",
      "profitableDescription": "잔액이 초기 자본과 입금액을 초과했습니다. 수익 분배 수수료는 위에 표시된 이익을 기준으로 계산됩니다.",
      "notProfitableDescription": "초기 자본과 입금액을 초과할 때까지 거래를 계속하세요. 그때까지는 수익 분배가 발생하지 않습니다.",
      "paymentRequired": "결제 필요",
      "paymentDescription": "지불해야 할 수익 분배 수수료가 ${{amount}}입니다.",
      "payNow": "지금 결제",
      "viewDetails": "수익 분배 세부 정보 보기",
    },
    "tradingHistory": {
      "title": "거래 기록 (앱 거래만)",
      "description": "DeepTrade 플랫폼에서 시작된 거래 표시",
      "loading": "로딩 중...",
      "headers": {
        "date": "날짜",
        "symbol": "심볼",
        "side": "방향",
        "size": "크기",
        "entry": "진입",
        "exit": "청산",
        "fees": "수수료",
        "pnl": "총손익",
        "status": "상태",
      },
      "noHistory": "거래 기록을 찾을 수 없습니다. 거래를 시작하여 여기에서 기록을 확인하세요.",
      "pagination": "{{pages}} 중 {{page}} 페이지 (총 {{total}} 거래)",
      "previous": "이전",
      "next": "다음",
    },
    "blockedUser": {
      "title": "거래 차단됨:",
      "message": "{{tier}} 등급에 대한 미지불 수익 분배. 미납액: ${{owed}}. 계속하려면 잔액을 정산하세요.",
    },
    "tooltips": {
      "balance": "연결된 거래소의 현재 계정 잔고.",
      "pnlToday": "오늘 마감된 거래에서 실현된 손익.",
      "monthlyRate": "백분율로 표시된 월간 수익률.",
      "winRate": "수익을 낸 거래의 백분율."
    }
  },
  "trading": {
    "title": "거래",
    "signals": "신호",
    "positions": "포지션",
    "history": "기록",
    "long": "롱",
    "short": "숏",
    "autoTrading": "자동 거래",
    "autoTradingActive": "자동 거래 활성",
    "autoTradingDisabled": "자동 거래 비활성",
    "autoTradingActiveDesc": "신호가 자동으로 실행됩니다",
    "autoTradingDisabledDesc": "거래 신호를 자동으로 실행하려면 활성화하세요",
    "noActiveSignals": "활성 신호 없음",
    "waitingForSignals": "새로운 거래 기회를 기다리는 중...",
    "enableAutoTrading": "신호를 받으려면 자동 거래를 활성화하세요",
    "refreshSignals": "신호 새로고침",
    "noOpenPositions": "열린 포지션 없음",
    "positionsDesc": "활성 거래 포지션이 여기에 표시됩니다",
    "noTradingHistory": "거래 기록 없음",
    "historyDesc": "완료된 거래가 여기에 표시됩니다",
    "executeTradeButton": "거래 실행",
    "viewDetailsButton": "세부 정보 보기",
    "entry": "진입",
    "stopLoss": "손절매",
    "takeProfit": "익절매",
    "confidence": "{{value}}% 신뢰도",
    "strategy": "전략",
    "firstTp": "첫 번째 TP",
    "secondTp": "두 번째 TP",
    "autoMoveStopLoss": "첫 번째 TP 후 SL을 손익분기점으로 자동 이동",
    "tradingMode": "거래 모드",
    "paperMode": "모의",
    "liveMode": "실제",
    "paperTradingActive": "모의 거래 활성",
    "liveTradingActive": "실제 거래 활성",
    "paperTradingDesc": "가상 자금으로 거래 연습",
    "liveTradingDesc": "실제 돈으로 거래",
    "virtualBalance": "가상 잔고",
    "unrealizedPnL": "미실현 손익",
    "equity": "자본",
    "paperTradingHelp": "모의 거래 도움말",
    "resetAccount": "계정 재설정",
    "paperTradingGuide": "모의 거래 가이드",
    "paperModeTitle": "모의 모드",
    "noProfitSharePaper": "모의 모드에서는 수익 분배 없음",
    "paperTradingPositions": "총 포지션:",
    "paperTradingHistory": "모의 거래 기록",
    "simulatedTradingHistory": "시뮬레이션 거래 기록",
    "noPaperPositions": "모의 거래 포지션 없음",
    "enableAutoTradingPaper": "모의 거래는 시장 신호를 기반으로 시뮬레이션 포지션을 자동으로 생성합니다",
    "paperTradingMode": "모의 거래 모드",
    "autoTradingNotAvailable": "자동 거래 사용 불가",
    "autoTradingDisabledPaper": "자동 거래는 실제 거래를 제어합니다. 모의 거래는 신호를 자동으로 생성합니다.",
    "riskManagement": "위험 관리",
    "riskSettings": "위험 설정",
    "investmentPercentage": "투자 비율",
    "leverage": "레버리지",
    "maxLeverage": "최대 레버리지",
    "currentTier": "현재 등급",
    "exchange": "거래소",
    "accountType": "계정 유형",
    "marketType": "시장 유형",
    "saveSettings": "설정 저장",
    "resetToSafe": "안전하게 재설정",
    "saving": "저장 중...",
    "riskSettingsSaved": "위험 설정이 성공적으로 저장되었습니다",
    "failedToSaveRiskSettings": "위험 설정 저장 실패",
    "position": "포지션",
    "internal": "내부",
    "external": "외부",
    "marketClose": "시장 마감",
    "reverse": "역전",
    "editTpSl": "TP/SL",
    "refreshActivePositions": "활성 포지션 새로고침",
    "youHaveNoPosition": "포지션이 없습니다.",
    "noActiveAppPositions": "활성 앱 포지션을 찾을 수 없습니다.",
    "noActiveExternalPositions": "활성 외부 포지션을 찾을 수 없습니다.",
    "yourActivePositionsWillAppear": "활성 거래 포지션이 여기에 표시됩니다.",
    "previous": "이전",
    "next": "다음",
    "learnMore": "더 알아보기",
    "paperTradingLabel": "모의 거래",
    "recentPaperTrades": "최근 모의 거래",
    "noPaperTrades": "아직 모의 거래가 없습니다",
    "paperTradingAutoGenerate": "모의 거래는 시장 신호를 기반으로 시뮬레이션 거래를 자동으로 생성합니다",
    "activePositionsTitle": "활성 포지션",
    "youHaveNoPositions": "포지션이 없습니다.",
    "yourActivePositionsWillAppearHere": "거래를 시작하거나 자동 거래를 활성화하면 활성 거래 포지션이 여기에 표시됩니다.",
    "max": "최대",
    "tooltips": {
      "virtualBalance": "마감된 거래에서 실현된 잔고. 계산식: 초기 잔고 + 모든 마감된 거래의 순손익 합계.",
      "unrealizedPnL": "현재 열려있는 포지션의 이익 또는 손실. 이 값은 현재 시장 가격에 따라 실시간으로 변경되며 아직 실현되지 않았습니다.",
      "equity": "열린 포지션을 포함한 총 계정 가치. 계산식: 가상 잔고 + 미실현 손익. 이것은 모의 거래에서의 현재 순자산을 나타냅니다.",
      "profitAndLoss": "마감된 거래에서만 실현된 손익. 열린 포지션의 미실현 손익은 포함되지 않습니다.",
      "balance": "거래에 사용 가능한 현재 계정 잔고.",
      "pnlToday": "오늘 마감된 거래에서 실현된 손익.",
      "monthlyRate": "초기 잔고의 백분율로 계산된 월간 수익률.",
      "winRate": "수익을 낸 마감된 거래의 백분율. 완료된 거래에서만 계산됩니다.",
      "totalReturn": "가상 잔고를 기반으로 한 총 수익률. 계산식: (현재 가상 잔고 - 초기 잔고) / 초기 잔고 × 100%."
    }
  },
  "common": {
    "loading": "로딩 중...",
    "error": "오류",
    "success": "성공",
    "save": "저장",
    "cancel": "취소",
    "yes": "예",
    "no": "아니오",
    "active": "활성",
    "inactive": "비활성",
    "on": "켜짐",
    "off": "꺼짐",
    "enabled": "활성화됨",
    "disabled": "비활성화됨",
    "for": "에 대해",
    "warning": "Warning",
    "info": "정보",
    "confirm": "확인",
    "edit": "Edit",
    "delete": "Delete",
    "close": "닫기",
    "back": "뒤로",
    "next": "다음",
    "previous": "이전",
    "submit": "Submit",
    "reset": "Reset",
    "search": "Search",
    "filter": "Filter",
    "sort": "Sort",
    "refresh": "Refresh",
    "enable": "활성화",
    "disable": "비활성화",
    "toggleOn": "ON",
    "toggleOff": "OFF",
    "ok": "확인",
    "apply": "적용",
    "clear": "지우기",
    "select": "선택",
    "upload": "업로드",
    "download": "다운로드",
    "copy": "복사",
    "copied": "복사됨!",
    "share": "Share",
    "print": "인쇄",
    "export": "Export",
    "import": "Import",
    "and": "그리고",  },
  "wallet": {
    "connect": "지갑 연결",
    "disconnect": "연결 해제",
    "connected": "연결됨",
    "notConnected": "연결되지 않음",
    "connecting": "연결 중...",
    "balance": "잔액",
    "address": "주소",
    "solanaBlockchain": "솔라나 블록체인 기반",
    "solanaTooltip": "솔라나 기반 구축 - 빠르고 안전하며 확장 가능한 블록체인",
    "wrongNetwork": "잘못된 네트워크",
    "switchNetwork": "네트워크 전환",
    "transactionPending": "거래 대기 중",
    "transactionConfirmed": "거래 확인됨",
    "transactionFailed": "거래 실패",
    "connectionError": "연결 오류",
    "connectionFailed": "지갑 연결 실패",
    "connectionRejected": "지갑 연결이 거부되었습니다",
    "walletNotFound": "솔라나 지갑을 찾을 수 없습니다. Phantom과 같은 지갑을 설치해주세요.",
    "disconnected": "지갑 연결 해제됨",
    "disconnectedSuccess": "지갑이 성공적으로 연결 해제되었습니다.",
    "disconnectError": "연결 해제 오류",
    "disconnectFailed": "지갑 연결 해제 실패.",
    "confirmDisconnect": "지갑 연결 해제 확인",
    "confirmDisconnectMessage": "정말로 지갑 연결을 해제하시겠습니까?",
  },
  "notifications": {
    "autoTradingEnabled": "자동 거래가 활성화되었습니다",
    "autoTradingDisabled": "자동 거래가 비활성화되었습니다",
    "settingsSaved": "설정이 성공적으로 저장되었습니다",
    "passwordChanged": "비밀번호가 성공적으로 변경되었습니다",
    "profileUpdated": "프로필이 성공적으로 업데이트되었습니다",
    "walletConnected": "지갑이 성공적으로 연결되었습니다",
    "walletDisconnected": "지갑 연결이 해제되었습니다",
    "signalExecuted": "거래 신호가 실행되었습니다",
    "tradeCompleted": "거래가 성공적으로 완료되었습니다",
    "paymentSuccessful": "결제가 성공적으로 처리되었습니다",
    "tierUpgraded": "티어가 성공적으로 업그레이드되었습니다",
    "autoTrading": {
      "enabledTitle": "자동 거래 활성화됨",
      "enabledDescription": "자동 거래가 성공적으로 활성화되었습니다. 잔액 요구사항이 확인되었습니다.",
      "disabledTitle": "자동 거래 비활성화됨",
      "disabledDescription": "자동 거래가 성공적으로 비활성화되었습니다.",
      "insufficientBalanceTitle": "잔액 부족",
      "insufficientBalanceDescription": "최소 {{required}} USDT 잔액이 필요합니다. 현재 잔액은 {{current}} USDT입니다.",
      "missingCredentialsTitle": "API 자격 증명 누락",
      "missingCredentialsDescription": "먼저 거래소 API 자격 증명을 추가하고 검증하세요.",
      "balanceVerificationFailedTitle": "잔액 확인 실패",
      "balanceVerificationFailedDescription": "계정 잔액 확인에 실패했습니다. API 자격 증명을 확인하세요.",
      "errorTitle": "자동 거래 오류",
      "errorDescription": "자동 거래 전환에 실패했습니다. 다시 시도하세요.",
      "systemDisabledTitle": "자동 거래 비활성화됨",
      "noApiCredentialsReason": "거래소 API 자격 증명이 구성되지 않았습니다. API 키를 추가해주세요.",
      "investmentPercentageReason": "투자 비율이 0%로 설정되어 있습니다. 위험 설정을 조정해주세요.",
    },
    "paperAutoTrading": {
      "enabledTitle": "페이퍼 자동 거래 활성화됨",
      "enabledDescription": "페이퍼 거래 신호가 이제 자동으로 실행됩니다",
      "disabledTitle": "페이퍼 자동 거래 비활성화됨",
      "disabledDescription": "페이퍼 거래 신호가 더 이상 자동으로 실행되지 않습니다",
      "errorTitle": "페이퍼 자동 거래 오류",
      "errorDescription": "페이퍼 자동 거래 전환에 실패했습니다"
    }
  },
  "errors": {
    "generic": "문제가 발생했습니다. 다시 시도해 주세요.",
    "network": "네트워크 오류입니다. 연결을 확인해 주세요.",
    "unauthorized": "이 작업을 수행할 권한이 없습니다.",
    "forbidden": "접근이 거부되었습니다.",
    "notFound": "요청한 리소스를 찾을 수 없습니다.",
    "serverError": "서버 오류입니다. 나중에 다시 시도해 주세요.",
    "validationError": "입력을 확인하고 다시 시도해 주세요.",
    "walletNotConnected": "먼저 지갑을 연결해 주세요.",
    "insufficientBalance": "잔액이 부족합니다.",
    "transactionFailed": "거래가 실패했습니다. 다시 시도해 주세요.",
    "apiError": "API 오류입니다. 문제가 지속되면 지원팀에 문의하세요.",
  },
  "settings": {
    "title": "계정 설정",
    "pleaseLogIn": "로그인해 주세요",
    "loginRequired": "계정 설정에 접근하려면 로그인이 필요합니다.",
    "goToLogin": "로그인하러 가기",
    "profile": {
      "title": "프로필 설정",
      "description": "계정 정보 및 설정을 관리하세요",
      "email": "이메일 주소",
      "currentEmail": "현재 이메일",
      "newEmail": "새 이메일 주소",
      "updateEmail": "이메일 업데이트",
      "sending": "전송 중...",
      "placeholders": {
        "newEmail": "새 이메일 주소를 입력하세요",
        "currentPassword": "현재 비밀번호를 입력하세요"
      }
    },
    "security": {
      "title": "보안 설정",
      "description": "비밀번호 및 보안 설정을 관리하세요",
      "changePassword": "비밀번호 변경",
      "currentPassword": "현재 비밀번호",
      "newPassword": "새 비밀번호",
      "confirmPassword": "새 비밀번호 확인",
      "enable2FA": "2단계 인증",
      "twoFactorEnabled": "계정에 2단계 인증이 활성화되어 있습니다",
      "twoFactorDisabled": "계정에 2단계 인증이 비활성화되어 있습니다",
      "changing": "변경 중...",
      "changePasswordButton": "비밀번호 변경",
      "verificationCode": "인증 코드",
      "verifyCode": "코드 확인",
      "verifying": "확인 중...",
      "cancel": "취소",
      "disable2FA": "2단계 인증 비활성화",
      "disable2FADescription": "정말로 2FA를 비활성화하시겠습니까? 이렇게 하면 계정 보안이 약해집니다. 이 작업을 확인하기 위해 이메일로 인증 코드를 보내드립니다.",
      "sendVerificationCode": "인증 코드 전송",
      "disabling": "비활성화 중...",
      "disable2FAButton": "2FA 비활성화",
      "resendCode": "코드 재전송",
      "verifyEmail": "이메일 확인",
      "verifyEmailDescription": "이메일로 6자리 인증 코드를 보내드렸습니다. 2FA를 활성화하려면 아래에 입력하세요.",
      "verifyEmailToDisable2FA": "2FA 비활성화를 위한 이메일 확인",
      "verifyEmailToDisable2FADescription": "이메일로 6자리 인증 코드를 보내드렸습니다. 2단계 인증을 비활성화하려면 아래에 입력하세요.",
      "placeholders": {
        "currentPassword": "현재 비밀번호를 입력하세요",
        "newPassword": "새 비밀번호를 입력하세요",
        "confirmPassword": "새 비밀번호를 확인하세요",
        "verificationCode": "6자리 코드를 입력하세요"
      }
    },
    "account": {
      "title": "위험 구역",
      "deleteAccount": "계정 삭제",
      "deleteAccountWarning": "계정을 삭제하면 되돌릴 수 없습니다. 신중하게 결정해 주세요.",
      "deleteAccountButton": "계정 삭제",
      "deleting": "삭제 중...",
      "deleteAccountModal": {
        "title": "계정 삭제",
        "description": "이 작업은 되돌릴 수 없습니다. 계정이 영구적으로 삭제되고 모든 관련 데이터가 제거됩니다.",
        "confirmText": "계정 삭제",
        "typedConfirmationText": "삭제",
        "permanentlyDelete": "다음이 영구적으로 삭제됩니다:",
        "consequences": [
          "모든 데이터를 영구적으로 삭제",
          "거래 기록 제거",
          "활성 구독 취소",
          "모든 API 자격 증명 제거",
          "모든 설정 및 기본 설정 삭제"
        ]
      }
    },
    "errors": {
      "fillAllFields": "모든 필드를 입력해 주세요",
      "passwordsNotMatch": "새 비밀번호가 일치하지 않습니다",
      "invalidVerificationCode": "인증 코드를 입력해 주세요",
      "invalid6DigitCode": "유효한 6자리 인증 코드를 입력해 주세요",
      "updateEmailFailed": "이메일 업데이트 실패",
      "changePasswordFailed": "비밀번호 변경 실패",
      "enable2FAFailed": "2FA 활성화 실패",
      "verify2FAFailed": "2FA 코드 확인 실패",
      "disable2FAFailed": "비활성화 인증 코드 전송 실패",
      "disable2FAVerifyFailed": "2FA 비활성화 실패",
      "deleteAccountFailed": "계정 삭제 실패"
    },
    "success": {
      "verificationEmailSent": "인증 이메일 전송됨",
      "verificationEmailDescription": "인증 지침을 위해 {{email}}을 확인해 주세요.",
      "passwordChanged": "비밀번호 변경됨",
      "passwordChangedDescription": "비밀번호가 성공적으로 업데이트되었습니다.",
      "2FACodeSent": "2FA 코드 전송됨",
      "2FACodeSentDescription": "인증 코드를 위해 이메일을 확인해 주세요.",
      "2FAEnabled": "2FA 활성화됨",
      "2FAEnabledDescription": "2단계 인증이 성공적으로 활성화되었습니다.",
      "verificationCodeSent": "인증 코드 전송됨",
      "verificationCodeSentDescription": "2FA 비활성화를 위한 6자리 인증 코드를 이메일로 확인해 주세요.",
      "2FADisabled": "2FA 비활성화됨",
      "2FADisabledDescription": "2단계 인증이 성공적으로 비활성화되었습니다.",
      "accountDeleted": "계정 삭제됨",
      "accountDeletedDescription": "계정이 성공적으로 삭제되었습니다."
    }
  },
  "accessSecurity": {
    "title": "접근 및 보안",
    "subtitle": "계정 보안 및 로그인 활동 모니터링",
    "totalLogins": "총 로그인",
    "successRate": "성공률",
    "uniqueIPs": "고유 IP",
    "twoFactorStatus": "2FA 상태",
    "enabled": "활성화됨",
    "disabled": "비활성화됨",
    "currentSession": "현재 세션",
    "currentSessionDescription": "현재 로그인 세션에 대한 정보",
    "recentLoginActivity": "최근 로그인 활동",
    "recentLoginDescription": "최근 로그인 시도 및 세션",
    "refresh": "새로고침",
    "ipAddress": "IP 주소",
    "timestamp": "타임스탬프",
    "status": "상태",
    "userAgent": "사용자 에이전트",
    "successful": "성공",
    "failed": "실패",
    "noLoginActivity": "로그인 활동이 없습니다",
    "currentDevice": "현재 기기",
    "location": "위치",
    "sessionStart": "세션 시작",
    "lastLoginActivity": "마지막 로그인 활동",
    "lastLoginDescription": "가장 최근 성공한 로그인",
    "loginTime": "로그인 시간",
    "browser": "브라우저",
    "lastThirtyDays": "지난 30일",
    "loginSuccessRate": "로그인 성공률",
    "differentLocations": "다른 위치들",
    "never": "없음",
    "unknown": "알 수 없음",
    "reason": "이유:",
    "authenticationRequired": "인증 필요",
    "authenticationRequiredDescription": "보안 정보를 보려면 로그인해주세요.",
    "errors": {
      "authenticationError": "인증 오류",
      "authenticationErrorDescription": "보안 데이터를 보려면 다시 로그인해주세요.",
      "networkError": "네트워크 오류",
      "networkErrorDescription": "보안 데이터를 가져오는데 실패했습니다. 연결을 확인해주세요.",
      "refreshFailed": "새로고침 실패",
      "refreshFailedDescription": "보안 데이터 새로고침에 실패했습니다. 다시 시도해주세요."
    },
    "success": {
      "dataRefreshed": "보안 데이터 새로고침됨",
      "dataRefreshedDescription": "보안 정보가 성공적으로 업데이트되었습니다."
    }
  },
  "tiers": {
    "title": "티어 관리",
    "currentTier": "현재 티어",
    "choosePlan": "플랜 선택",
    "tier1": {
      "name": "티어 1",
      "subtitle": "무료",
      "description": "기본 거래 신호로 시작하기에 완벽",
      "features": [
        "기본 거래 신호",
        "수동 거래 실행",
        "커뮤니티 지원",
        "기본 시장 분석"
      ]
    },
    "tier2": {
      "name": "티어 2",
      "subtitle": "30일 액세스",
      "description": "진지한 트레이더를 위한 고급 기능",
      "features": [
        "고급 AI 거래 신호",
        "자동 거래 기능",
        "우선 지원",
        "고급 분석",
        "위험 관리 도구"
      ]
    },
    "tier3": {
      "name": "티어 3",
      "subtitle": "NFT 필요",
      "description": "독점 기능이 있는 프리미엄 티어",
      "features": [
        "프리미엄 거래 신호",
        "고급 자동 거래",
        "VIP 지원",
        "독점 시장 인사이트",
        "맞춤 전략"
      ]
    },
    "activate": "활성화",
    "current": "현재",
    "paymentRequired": "결제 필요",
    "nftRequired": "NFT 필요",
    "membershipStatus": "멤버십 상태",
    "active": "활성",
    "expired": "만료됨",
    "daysRemaining": "남은 일수",
    "expiresOn": "만료일",
  },
  "apiCredentials": {
    "title": "API 자격 증명",
    "description": "거래를 위한 거래소 API 자격 증명 관리",
    "addCredentials": "API 자격 증명 추가",
    "exchange": "거래소",
    "exchanger": "거래소",
    "apiKey": "API 키",
    "apiSecret": "API 시크릿",
    "secretKey": "시크릿 키",
    "passphrase": "패스프레이즈",
    "testConnection": "연결 테스트",
    "save": "자격 증명 저장",
    "edit": "편집",
    "delete": "삭제",
    "status": "상태",
    "connected": "연결됨",
    "disconnected": "연결 해제됨",
    "invalid": "유효하지 않음",
    "active": "활성",
    "testing": "테스트 중...",
    "connectionSuccess": "연결 성공",
    "connectionFailed": "연결 실패",
    "credentialsAdded": "API 자격 증명이 성공적으로 추가되었습니다",
    "credentialsUpdated": "API 자격 증명이 성공적으로 업데이트되었습니다",
    "credentialsDeleted": "API 자격 증명이 성공적으로 삭제되었습니다",
    "credentialAddedLimitReached": "자격 증명 추가됨 (한도 도달)",
    "requiredMarketType": "필수 시장 유형",
    "connectedTo": "연결됨:",
    "connectionNeedsAttention": "연결 필요:",
    "needsAttention": "주의 필요",
    "lastUpdated": "마지막 업데이트",
    "updateCredentialsMessage": "거래를 계속하려면 API 자격 증명을 업데이트하세요",
    "disconnect": "연결 해제",
    "disconnecting": "연결 해제 중...",
    "setAsActive": "활성으로 설정",
    "activating": "활성화 중...",
    "autoTrading": "자동 거래",
    "enableAutoTradingDesc": "이 거래소에서 자동 거래 활성화",
    "tier2LimitReached": "티어 2 한도 도달: 최대 두 개의 CEX 자격 증명 허용.",
    "add": "추가",
    "update": "업데이트",
    "connectionValidated": "연결 검증됨!",
    "autoTradingStatusChanged": "자동 거래가",
    "marketTypes": {
      "futures": "선물",
      "spot": "현물",
      "binanceNote": "선물 거래 - 최대 125배 레버리지 사용 가능",
      "binanceUsNote": "마진이 있는 현물 거래 - 최대 3배 레버리지 사용 가능",
      "krakenNote": "선물 거래 - 최대 100배 레버리지 사용 가능",
      "bybitNote": "선물 거래 - 최대 100배 레버리지 사용 가능",
      "hyperliquidNote": "무기한 선물 거래 - 최대 50배 레버리지 사용 가능",
      "standardNote": "표준 현물 거래",
    },
    "errors": {
      "loadFailed": "자격 증명 로드 실패",
      "keysRequired": "API 키와 시크릿 키가 필요합니다",
      "tierUndetermined": "사용자 티어를 확인할 수 없습니다",
      "tier1Limit": "티어 1은 하나의 API 자격 증명만 허용합니다",
      "tier2PerCex": "티어 2는 CEX당 하나의 자격 증명만 허용합니다",
      "tier2Limit": "티어 2는 최대 두 개의 자격 증명을 허용합니다 (CEX당 하나)",
      "tier3Limit": "티어 3은 모든 CEX에 대해 하나의 자격 증명만 허용합니다",
      "saveFailed": "저장 실패",
      "validationFailed": "검증 실패",
      "activationFailed": "활성화 실패",
      "deactivationFailed": "비활성화 실패",
      "noCredentials": "이 거래소에 대한 자격 증명을 찾을 수 없습니다",
      "autoTradingUpdateFailed": "자동 거래 업데이트 실패",
      "autoTradingUpdateFailedDesc": "자동 거래 설정 업데이트 실패",
    },
    "success": {
      "credentialsSaved": "자격 증명 저장됨",
      "connectionSuccessful": "연결 성공",
      "activated": "활성화됨",
      "deactivated": "비활성화됨",
      "autoTradingEnabled": "자동 거래 활성화됨",
      "autoTradingDisabled": "자동 거래 비활성화됨",
    }
  },
  "referrals": {
    "title": "추천 대시보드",
    "loading": "추천 대시보드 로딩 중...",
    "referralLink": "추천 링크",
    "referralLinkDescription": "이 링크를 공유하여 추천인의 수익 공유 결제에서 {{rate}}%를 획득하세요.",
    "tierNames": {
      "tier1": "티어 1",
      "tier2": "티어 2",
      "tier3": "티어 3"
    },
    "settings": {
      "title": "설정",
      "referralSettings": "추천 설정",
      "solanaWalletAddress": "솔라나 지갑 주소",
      "walletPlaceholder": "결제를 위한 솔라나 지갑 주소를 입력하세요",
      "minimumPayoutAmount": "최소 지급 금액 ($)",
      "enableAutomaticPayments": "자동 결제 활성화",
      "autoPaymentEnabled": "활성화되면 추천 결제가 만료될 때 자동으로 받게 됩니다.",
      "autoPaymentDisabled": "비활성화되면 이것이 다시 활성화될 때까지 추천 결제를 받지 않습니다.",
      "saveSettings": "설정 저장",
      "importantWarning": "중요한 경고:",
      "warnings": {
        "ensureCorrectAddress": "솔라나 지갑 주소가 정확한지 확인해 주세요",
        "doubleCheckAddress": "저장하기 전에 주소를 다시 한 번 확인하세요",
        "notResponsible": "DeepTrade는 잘못되거나 유효하지 않은 주소로 전송된 결제에 대해 책임지지 않습니다",
        "cannotRecover": "잘못된 주소로 인해 손실된 자금은 복구할 수 없습니다"
      },
      "minimumPayoutRequirements": "최소 지급 요구사항:",
      "requirements": {
        "minimumAmount": "최소 지급 금액: $10.00 USDT",
        "gasFeeDeducted": "솔라나 네트워크 가스 수수료가 지급액에서 차감됩니다",
        "estimatedGasFee": "예상 가스 수수료: ~0.001 SOL (~$0.10-$0.50)",
        "payoutsProcessed": "지급은 솔라나 네트워크에서 USDT로 처리됩니다"
      }
    },
    "overview": {
      "totalReferrals": "총 추천 수",
      "activeCount": "{{count}}명 활성",
      "totalEarnings": "총 수익",
      "totalPaid": "${{amount}} 지급됨",
      "pendingPayout": "대기 중인 지급",
      "requestPayout": "지급 요청",
      "earningRate": "수익률"
    },
    "actions": {
      "copy": "복사",
      "generateNew": "새로 생성"
    },
    "recentActivity": {
      "recentReferrals": "최근 추천",
      "recentEarnings": "최근 수익",
      "noReferrals": "아직 추천이 없습니다. 링크 공유를 시작하세요!",
      "noEarnings": "아직 수익이 없습니다. 추천인들이 거래를 시작해야 합니다!",
      "earned": "${{amount}} 획득"
    },
    "status": {
      "verified": "확인됨",
      "pending": "대기 중",
      "paid": "지급됨"
    },
    "messages": {
      "copied": "복사됨!",
      "linkCopied": "추천 링크가 클립보드에 복사되었습니다",
      "newCodeGenerated": "새 추천 코드가 생성되었습니다",
      "profileUpdated": "프로필이 성공적으로 업데이트되었습니다",
      "payoutRequestSubmitted": "지급 요청이 제출되었습니다"
    },
    "errors": {
      "failedToLoadData": "추천 데이터 로드 실패",
      "failedToGenerateCode": "새 코드 생성 실패",
      "invalidMinimumPayout": "유효하지 않은 최소 지급액",
      "minimumPayoutRequired": "최소 지급액은 최소 $10.00이어야 합니다",
      "invalidWalletAddress": "유효하지 않은 지갑 주소",
      "validWalletRequired": "유효한 솔라나 지갑 주소를 입력해 주세요",
      "failedToUpdateProfile": "프로필 업데이트 실패",
      "failedToRequestPayout": "지급 요청 실패"
    }
  },

  "paperTradingHelp": {
    "title": "모의 거래 가이드",
    "whatIsPaperTrading": "모의 거래란 무엇인가요?",
    "whatIsPaperTradingDesc": "모의 거래는 실제 자금 대신 가상 화폐를 사용하여 거래 전략을 연습할 수 있는 시뮬레이션 거래 환경입니다. 금융적 위험 없이 AI 거래 시스템을 테스트하는 완벽한 방법입니다.",
    "keyBenefits": "주요 이점",
    "riskFree": "무위험 학습",
    "riskFreeDesc": "가상 자금으로 연습 - 실제 돈의 위험 없음",
    "realMarketData": "실제 시장 데이터",
    "realMarketDataDesc": "실시간 시장 상황과 가격 움직임 경험",
    "aiTradingSystem": "AI 거래 시스템",
    "aiTradingSystemDesc": "안전한 환경에서 고급 AI 신호 테스트",
    "buildConfidence": "자신감 구축",
    "buildConfidenceDesc": "실제 돈을 사용하기 전에 거래 기술 개발",
    "howItWorks": "작동 방식",
    "step1": "모의 모드로 전환",
    "step1Desc": "거래 모드 토글을 전환하여 모의 거래 활성화",
    "step2": "가상 잔액",
    "step2Desc": "$10,000 가상 잔액으로 시작 (재설정 가능)",
    "step3": "AI 신호",
    "step3Desc": "AI가 실제 시장 데이터를 기반으로 거래 신호 생성",
    "step4": "시뮬레이션 거래",
    "step4Desc": "거래가 가상으로 실행됨 - 성과 추적",
    "importantNotes": "중요 사항",
    "noRealMoney": "실제 돈 없음",
    "noRealMoneyDesc": "모의 거래는 가상 자금만 사용합니다. 실제 수익이나 손실은 발생하지 않습니다.",
    "noRealFees": "실제 수수료 없음",
    "noRealFeesDesc": "거래 수수료와 슬리피지는 현실적인 경험을 위해 시뮬레이션됩니다.",
    "performanceTracking": "성과 추적",
    "performanceTrackingDesc": "모든 통계와 분석은 시뮬레이션 거래만을 기반으로 합니다.",
    "readyToStart": "시작할 준비가 되셨나요?",
    "readyToStartDesc": "\"거래 모드\" 스위치를 \"모의\"로 전환하고 오늘부터 가상 자금으로 연습을 시작하세요!",
    "buildConfidenceFooter": "💪 실제 돈을 위험에 빠뜨리기 전에 모의 거래로 자신감을 쌓으세요!",
    "resetModal": {
      "title": "모의 거래 계정 재설정",
      "warning": "경고: 이 작업은 되돌릴 수 없습니다",
      "warningDesc": "모든 모의 거래 기록이 영구적으로 삭제되고 가상 잔액이 재설정됩니다.",
      "resetLimitReached": "일일 재설정 한도 도달",
      "resetLimitReachedDesc": "오늘 3회 재설정을 모두 사용했습니다. 한도는 UTC 자정에 재설정됩니다.",
      "resetsRemaining": "오늘 남은 재설정 횟수: {{count},",
      "currentBalance": "현재 잔액: ${{balance},",
      "resetToDefault": "기본값 $10,000으로 재설정",
      "customBalance": "사용자 정의 잔액 설정",
      "customBalanceDesc": "사용자 정의 시작 잔액 입력 (최소 $1,000)",
      "confirmationRequired": "'RESET'을 입력하여 확인",
      "confirmationPlaceholder": "여기에 RESET 입력...",
      "confirmationRequiredError": "확인하려면 'RESET'을 입력해주세요",
      "invalidBalance": "잘못된 잔액",
      "invalidBalanceDesc": "유효한 양수 잔액 금액을 입력해주세요",
      "resetting": "재설정 중...",
      "resetButton": "계정 재설정",
    },
    "howItWorksModal": {
      "title": "모의 거래 작동 방식",
      "step1": "$10,000 가상 잔액으로 시작 (설정 가능)",
      "step2": "AI가 자동으로 거래를 실행하도록 자동 거래 활성화",
      "step3": "성과를 모니터링하고 필요에 따라 위험 설정 조정",
      "step4": "시스템에 확신이 생기면 실제 거래로 전환",
    },
    "importantNotesDetails": {
      "noRealMoneyTitle": "실제 돈 없음:",
      "noRealMoneyDesc": "모의 거래는 가상 자금만 사용합니다. 실제 수익이나 손실은 발생하지 않습니다.",
      "noFeesTitle": "수수료 없음:",
      "noFeesDesc": "모의 거래는 실제 수익이 발생하지 않으므로 수익 분배 수수료가 발생하지 않습니다.",
      "resetLimitTitle": "재설정 제한:",
      "resetLimitDesc": "하루에 최대 3번까지 모의 계정을 재설정할 수 있습니다.",
    },
    "benefits": {
      "title": "모의 거래의 이점",
      "riskFreeLearning": "무위험 학습",
      "riskFreeLearningDesc": "AI 시스템 작동 방식을 배우면서 실제 돈을 잃지 않고 연습하세요",
      "strategyTesting": "전략 테스트",
      "strategyTestingDesc": "다양한 위험 설정을 테스트하고 시간이 지남에 따라 어떻게 작동하는지 확인하세요",
      "realMarketData": "실제 시장 데이터",
      "realMarketDataDesc": "실제 경험을 위해 실시간 시장 가격과 실제 ML 예측을 사용합니다",
    },
    "gettingStarted": {
      "title": "시작할 준비가 되셨나요?",
      "description": "\"거래 모드\" 스위치를 \"모의\"로 전환하고 오늘부터 가상 자금으로 연습을 시작하세요!",
      "buildConfidenceFooter": "💪 실제 돈을 위험에 빠뜨리기 전에 모의 거래로 자신감을 키우세요!",
    },
    "perfectForBeginners": "💡 새로운 전략을 테스트하고 싶은 초보자와 경험 있는 트레이더에게 완벽합니다!",
    "availableToAllTitle": "모든 사용자 이용 가능:",
    "availableToAllDesc": "모의 거래는 티어 레벨에 관계없이 모든 사용자가 이용할 수 있습니다.",
    "gotItThanks": "알겠습니다, 감사합니다!",
  },

  "paperTradingDashboard": {
    "performance": {
      "title": "모의 거래 성과",
      "refresh": "새로고침",
      "reset": "재설정",
      "totalReturn": "총 수익률",
    },

    "errors": {
      "loadFailed": "모의 거래 데이터 로드 실패",
    }
  },
  "tradingSignalStatus": {
    "title": "거래 신호 상태",
    "description": "시스템 전체 신호 방송의 실시간 상태",
    "signalLabel": "신호",
    "confidenceLabel": "AI 신호 신뢰도",
    "lastUpdateLabel": "마지막 업데이트",
    "errorLoading": "거래 상태를 불러오지 못했습니다",
    "signals": {
      "HOLD": "보유",
      "BUY": "매수",
      "SELL": "매도",
      "LONG": "롱",
      "SHORT": "숏",
      "long": "롱",
      "short": "숏"
    }
  },
  "pagination": {
    "show": "표시:",
    "perPage": "페이지당",
    "showing": "{{total}}개 중 {{start}}~{{end}}개 표시"
  },
  "tier": {
    "choosePlan": "플랜을 선택하세요",
    "membershipStatus": {
      "title": "멤버십 상태",
      "active": "활성",
      "expired": "만료됨",
      "daysRemaining": "남은 일수:",
      "expiresOn": "만료일:"
    },
    "modals": {
      "activateTier": "{{tierName}} 티어 활성화",
      "confirmActivation": "{{tierName}} 티어를 활성화하시겠습니까?",
      "confirmTierChange": "티어 변경 확인",
      "confirmSwitch": "{{tierName}} 티어로 전환하시겠습니까?",
      "cancel": "취소",
      "activate": "활성화",
      "confirm": "확인"
    },
    "tiers": {
      "starter": {
        "name": "티어 1: 스타터",
        "price": "무료",
        "description": "시작하기에 완벽함",
        "features": [
          "기본 트레이딩 신호",
          "최대 2.5배 트레이딩 레버리지",
          "하나의 API 액세스로 제한",
          "40% 수익 공유 수수료"
        ]
      },
      "pro": {
        "name": "티어 2: 프로",
        "description": "진지한 트레이더를 위한",
        "accessInstructions": "이 티어에 액세스하려면 상단 네비게이션 바의 지갑 버튼을 사용하여 솔라나 지갑을 연결하고 30일 액세스 비용을 지불하세요.",
        "features": [
          "고급 트레이딩 신호",
          "최대 5배 트레이딩 레버리지",
          "두 개의 API 액세스로 제한",
          "20% 수익 공유 수수료"
        ]
      },
      "nftElite": {
        "name": "티어 3: NFT 엘리트",
        "price": "평생",
        "description": "검증된 Capitolchilax NFT 수집가를 위한.",
        "visitWebsite": "capitolchilax.com 방문",
        "accessInstructions": "이 티어에 액세스하려면 상단 네비게이션 바의 지갑 버튼을 사용하여 연결하고 NFT 자격을 확인하세요.",
        "features": [
          "고급 트레이딩 신호",
          "최대 10배 트레이딩 레버리지",
          "무제한 API 연결",
          "10% 수익 공유 수수료",
          "월 멤버십 수수료 없음"
        ]
      }
    },
    "status": {
      "currentTier": "현재 티어",
      "alreadyUnlocked": "이미 잠금 해제됨",
      "yourCurrentTier": "현재 티어",
      "currentlyOn": "현재 {{tierName}}에 있습니다"
    },
    "buttons": {
      "paymentRequired": "결제 필요",
      "connectWallet": "지갑 연결",
      "nftRequired": "NFT 필요",
      "select": "{{tierName}} 선택",
      "activate": "{{tierName}} 활성화",
      "payToReactivate": "재활성화를 위해 결제",
      "payWithToken": "{{token}}로 결제",
      "connectWalletFirst": "먼저 지갑 연결",
      "proceedWithPayment": "결제 진행"
    },
    "nft": {
      "verifyingOwnership": "NFT 소유권 확인 중...",
      "nftRequired": "이 티어에 액세스하려면 특정 NFT를 소유해야 합니다",
      "nftOwned": "필요한 컬렉션의 NFT를 소유하고 있습니다."
    },
    "payment": {
      "thirtyDaysAccess": "30일 액세스",
      "thirtyDaysAccessDue": "30일 액세스 만료",
      "paymentDetails": "결제 세부사항",
      "amount": "금액:",
      "network": "네트워크:",
      "wallet": "지갑:",
      "connectionStatus": "연결 상태:",
      "connected": "연결됨",
      "disconnected": "연결 해제됨",
      "processing": "결제 처리 중",
      "processingDescription": "지갑에서 거래를 확인하고 확인을 기다려 주세요...",
      "successful": "결제 성공!",
      "successDescription": "결제가 성공적으로 처리되었습니다. 티어가 곧 업데이트됩니다.",
      "failed": "결제 실패",
      "failedDescription": "결제 처리 중 오류가 발생했습니다. 다시 시도해 주세요.",
      "tryAgain": "다시 시도",
      "thirtyDaysAccessDescription": "프로 기능을 활성화하려면 30일 액세스 결제를 완료하세요.",
      "importantNotes": "중요 사항",
      "paymentWarnings": [
        "지갑에 충분한 {{token}}이 있는지 확인하세요",
        "거래 수수료를 위해 약간의 SOL을 보관하세요 (~0.001 SOL)",
        "결제는 솔라나 메인넷에서 처리됩니다",
        "거래는 확인 후 되돌릴 수 없습니다"
      ]
    },
    "paymentHistory": {
      "title": "결제 내역",
      "profitShare": "수익 공유",
      "thirtyDaysAccess": "30일 액세스",
      "billingPeriod": "{{startDate}} - {{endDate}}에 대해 ${{amount}} 만료"
    },
    "errors": {
      "paymentRequired": "티어를 변경하기 전에 미결제 수익 공유 수수료(${{amount}})를 지불해야 합니다.",
      "downgradeNotAllowed": "티어 {{currentTier}}에서 티어 {{newTier}}로 다운그레이드할 수 없습니다. 더 높은 티어로만 업그레이드할 수 있습니다.",
      "downgradeNotAllowedTitle": "다운그레이드 허용되지 않음",
      "walletConnectionRequired": "티어 2에 액세스하려면 솔라나 지갑을 연결해 주세요.",
      "walletConnectionRequiredTitle": "지갑 연결 필요",
      "nftRequired": "이 티어에 액세스하려면 특정 NFT를 소유해야 합니다.",
      "membershipExpired": "티어 2 멤버십이 만료되었습니다. 스타터 티어로 다운그레이드되었습니다.",
      "membershipExpiredTitle": "멤버십 만료",
      "walletDisconnected": "티어 상태가 보존되었습니다.",
      "walletDisconnectedTitle": "지갑 연결 해제",
      "walletDisconnectedWithDays": "티어 2 액세스가 {{days}}일 더 활성 상태로 유지됩니다.",
      "couldNotValidate": "티어 상태가 보존되었습니다. 결제를 위해 지갑을 다시 연결하세요.",
      "failedToFetchTier": "티어 상태 가져오기 실패",
      "errorLoadingTier": "티어 정보 로딩 오류",
      "dataFetchError": "티어 데이터 가져오기 실패: {{error}}",
      "dataFetchErrorTitle": "데이터 가져오기 오류",
      "walletNotConnected": "결제를 진행하려면 솔라나 지갑을 연결해 주세요.",
      "walletNotConnectedTitle": "지갑이 연결되지 않음",
      "paymentFailed": "결제 처리 중 오류가 발생했습니다. 다시 시도해 주세요.",
      "paymentSuccessful": "{{type}} 결제가 성공적으로 처리되었습니다!",
      "activationFailed": "티어 활성화 실패. 다시 시도해 주세요."
    },
    "profitShare": {
      "paymentDueTitle": "수익 공유 결제 만료",
      "accountDisabled": "계정 비활성화",
      "status": "수익 공유 상태",
      "paymentWasDue": "결제 만료일:",
      "paymentDue": "결제 만료:",
      "nextPaymentDeadline": "다음 결제 마감일:",
      "payNow": "지금 결제",
      "payToReactivate": "재활성화를 위해 결제",
      "overdue": "연체",
      "accountDisabledMessage": "계정 비활성화 - 결제 필요",
      "paymentOverdue": "결제 연체",
      "paymentDueSoon": "결제 곧 만료",
      "wasDue": "만료일:",
      "due": "만료:",
      "youOwe": "수익 공유 수수료 ${{amount}}를 지불해야 합니다",
      "allCaughtUp": "미결제 수익 공유 수수료 없음 - 모든 것이 최신 상태입니다! 🎉",
      "scheduleInfo": "수익 공유 결제는 매주 토요일 GMT 0:00에 만료됩니다",
      "disableWarning": "계정은 미결제 수수료로 인해 매주 토요일 GMT 0:00에 비활성화됩니다",
      "deadlineApproaching": "결제 마감일 접근",
      "deadlineMessage": "${{amount}}의 수익 공유 결제가 토요일 GMT 0:00까지 만료됩니다. 마감일까지 결제가 접수되지 않으면 계정이 자동으로 비활성화됩니다.",
      "accountTradingDisabled": "계정 트레이딩 비활성화",
      "accountDisabledDescription": "미결제 수익 공유 수수료로 인해 트레이딩 계정이 비활성화되었습니다. 트레이딩을 재활성화하려면 ${{amount}}를 지불하세요.",
      "accountSuspendedWarning": "⚠️ 미결제 수수료로 인해 계정이 비활성화되었습니다. 결제가 완료될 때까지 트레이딩이 중단됩니다.",
      "disabledOn": "비활성화일:",
      "deadline": "마감일:"
    },
    "coupon": {
      "redeemButton": "쿠폰이 있으신가요? 여기서 사용하세요",
      "redeemDescription": "쿠폰 코드로 즉시 티어를 업그레이드하세요"
    },
    "pricing": {
      "free": "무료",
      "lifetime": "평생",
      "thirtyDayAccess": "30일 액세스에 ${{price}}"
    },
    "success": {
      "tierUpdated": "티어가 {{tierName}}로 업데이트되었습니다.",
      "tierActivated": "티어가 성공적으로 업데이트되었습니다.",
      "paymentSuccessful": "{{type}} 결제가 성공적으로 처리되었습니다!"
    },
    "notifications": {
      "accountDisabled": {
        "title": "🚫 계정 비활성화",
        "description": "${{amount}}의 미결제 수익 공유 수수료로 인해 계정이 비활성화되었습니다. 계정을 재활성화하려면 결제해 주세요."
      },
      "paymentOverdue": {
        "title": "⚠️ 결제 연체",
        "description": "${{amount}}의 수익 공유 결제가 연체되었습니다. 계정이 곧 비활성화될 수 있습니다."
      },
      "paymentReminder": {
        "title": "⏰ 결제 알림",
        "description": "${{amount}}의 수익 공유 결제가 토요일 GMT 0:00에 만료됩니다. 계정 정지를 피하려면 결제해 주세요."
      }
    }
  },
  "help": {
    "title": "도움말 및 지원",
    "description": "자주 묻는 질문에 대한 답변을 찾고, 법적 정책을 검토하며, 지원팀에 문의하세요.",
    "faqTab": "자주 묻는 질문",
    "legalTab": "법적 사항",
    "contactTab": "문의",
    "faqSection": {
      "categories": {
        "general": "일반",
        "trading": "거래",
        "tiers": "티어",
        "setup": "설정",
        "security": "보안",
        "billing": "결제"
      },
      "items": {
        "whatIsDeepTrade": {
          "question": "DeepTrade란 무엇인가요?",
          "answer": "DeepTrade는 고급 머신러닝 알고리즘을 사용하여 자동화된 거래 신호와 포트폴리오 관리 도구를 제공하는 AI 기반 암호화폐 거래 플랫폼입니다."
        },
        "howSignalsWork": {
          "question": "거래 신호는 어떻게 작동하나요?",
          "answer": "우리의 AI는 실시간으로 시장 데이터를 분석하여 진입점, 손절매, 이익실현 수준이 포함된 매수/매도 신호를 생성합니다. 수동으로 실행하거나 자동 거래를 활성화할 수 있습니다."
        },
        "tierLevels": {
          "question": "다양한 티어 레벨은 무엇인가요?",
          "answer": "티어 1 (무료): 기본 신호. 티어 2 ($50/월): 고급 신호 + 자동 거래. 티어 3 (NFT 필요): 프리미엄 기능 + 우선 지원."
        },
        "connectExchange": {
          "question": "거래소 계정을 어떻게 연결하나요?",
          "answer": "대시보드의 API 자격 증명으로 이동하여 거래소 API 키를 추가하고(읽기 전용 권장), 시스템이 연결을 검증합니다."
        },
        "dataSecure": {
          "question": "내 데이터가 안전한가요?",
          "answer": "네, 업계 표준 암호화를 사용하고, 개인 키를 저장하지 않으며, 최대 보안을 위해 읽기 전용 API 액세스를 권장합니다."
        },
        "profitShares": {
          "question": "수익 공유는 어떻게 작동하나요?",
          "answer": "티어 2+ 사용자의 경우, 신호를 통해 생성된 수익의 작은 비율을 청구합니다. 이는 우리의 이익을 귀하의 성공과 일치시킵니다."
        },
        "cancelSubscription": {
          "question": "언제든지 구독을 취소할 수 있나요?",
          "answer": "네, 언제든지 구독을 다운그레이드하거나 취소할 수 있습니다. 현재 결제 기간이 끝날 때까지 액세스를 유지합니다."
        },
        "supportedExchanges": {
          "question": "지원되는 거래소는 무엇인가요?",
          "answer": "현재 Binance, Coinbase Pro, Kraken 등 주요 거래소를 지원합니다. 전체 목록은 API 자격 증명 페이지를 확인하세요."
        }
      }
    },
    "legal": {
      "documents": "법적 문서",
      "englishNotice": "법적 명확성을 위해 항상 영어로 표시됩니다",
      "privacy": {
        "title": "개인정보 보호정책",
        "description": "개인정보 보호정책은 DeepTrade 서비스를 사용할 때 개인 정보를 수집, 사용 및 보호하는 방법을 설명합니다. 데이터의 개인정보 보호와 보안을 유지하는 데 전념하고 있습니다.",
        "highlights": {
          "title": "주요 개인정보 보호 하이라이트:",
          "item1": "서비스 제공에 필요한 정보만 수집합니다",
          "item2": "거래 데이터는 암호화되어 안전하게 저장됩니다",
          "item3": "개인 정보를 제3자에게 판매하지 않습니다",
          "item4": "데이터와 개인정보 보호 설정을 제어할 수 있습니다"
        },
        "viewFull": "전체 개인정보 보호정책 보기"
      },
      "terms": {
        "title": "서비스 약관",
        "description": "서비스 약관은 DeepTrade 플랫폼과 서비스 사용을 규정합니다. 플랫폼을 사용함으로써 이러한 약관과 조건에 동의합니다.",
        "highlights": {
          "title": "주요 약관 하이라이트:",
          "item1": "플랫폼 사용 권리 및 제한",
          "item2": "사용자 책임 및 의무",
          "item3": "서비스 가용성 및 제한",
          "item4": "계정 해지 및 정지 정책"
        },
        "viewFull": "전체 서비스 약관 보기"
      },
      "risks": {
        "title": "위험 공시"
      }
    },
    "contact": {
      "title": "지원팀 문의",
      "form": {
        "name": "이름",
        "email": "이메일",
        "subject": "제목",
        "message": "메시지",
        "sendMessage": "메시지 보내기",
        "sending": "전송 중...",
        "placeholders": {
          "name": "전체 이름",
          "email": "your.email@example.com",
          "subject": "문제에 대한 간단한 설명",
          "message": "문제를 자세히 설명해 주세요..."
        }
      },
      "guidelines": {
        "title": "지원 가이드라인",
        "before": {
          "title": "지원팀 문의 전",
          "item1": "먼저 이 FAQ 섹션을 확인하세요",
          "item2": "계정 설정을 검토하세요",
          "item3": "API 자격 증명을 확인하세요",
          "item4": "알려진 문제에 대한 상태 페이지를 확인하세요"
        },
        "when": {
          "title": "지원팀 문의 시",
          "item1": "계정 이메일을 포함하세요",
          "item2": "문제를 자세히 설명하세요",
          "item3": "해당하는 경우 스크린샷을 제공하세요",
          "item4": "오류 메시지를 포함하세요"
        },
        "notice": {
          "title": "중요 공지",
          "message": "개인 키, 비밀번호 또는 API 비밀 키를 요청하지 않습니다. 이 정보를 안전하게 보관하고 누구와도 공유하지 마세요."
        }
      },
      "errors": {
        "missingInformation": "정보 누락",
        "fillAllFields": "제출하기 전에 모든 필드를 입력해 주세요.",
        "failedToSend": "메시지 전송 실패",
        "error": "오류",
        "tryAgainLater": "메시지 전송에 실패했습니다. 나중에 다시 시도해 주세요."
      },
      "success": {
        "messageSent": "메시지 전송됨!",
        "thankYou": "문의해 주셔서 감사합니다. 24-48시간 내에 답변드리겠습니다."
      }
    }
  },
  "redeemCoupon": {
    "title": "쿠폰 사용",
    "subtitle": "쿠폰 코드를 입력하여 티어를 업그레이드하세요",
    "currentTier": "현재 티어:",
    "couponCode": "쿠폰 코드",
    "placeholder": "쿠폰 코드 입력 (예: DTABC123)",
    "formatHint": "코드는 4-20자, 영문자와 숫자만 가능합니다",
    "redeemButton": "쿠폰 사용",
    "redeeming": "사용 중...",
    "backToTier": "← 티어 관리로 돌아가기",
    "tierNames": {
      "starter": "스타터 (무료)",
      "pro": "프로 (프리미엄)",
      "vip": "VIP (엘리트)",
      "unknown": "알 수 없음"
    },
    "howItWorks": {
      "title": "사용 방법:",
      "steps": [
        "위에 쿠폰 코드를 입력하세요",
        "티어가 자동으로 업그레이드됩니다",
        "새로운 기능에 즉시 액세스할 수 있습니다",
        "각 쿠폰은 한 번만 사용할 수 있습니다"
      ]
    },
    "errors": {
      "invalidInput": "잘못된 입력",
      "enterCouponCode": "쿠폰 코드를 입력해주세요",
      "invalidFormat": "잘못된 형식",
      "formatRequirement": "쿠폰 코드는 4-20자, 영문자와 숫자만 가능합니다",
      "redemptionFailed": "사용 실패",
      "failedToRedeem": "쿠폰 사용에 실패했습니다",
      "networkError": "네트워크 오류",
      "connectionFailed": "서버 연결에 실패했습니다. 다시 시도해주세요."
    },
    "success": {
      "redeemed": "쿠폰이 성공적으로 사용되었습니다!",
      "validFor": "({{days}}일 동안 유효)"
    }
  },
  "oauthCallback": {
    "loading": {
      "title": "인증 중...",
      "description": "인증을 완료하는 동안 잠시 기다려 주세요."
    },
    "error": {
      "title": "인증 오류",
      "returnToLogin": "로그인으로 돌아가기",
      "tryAgain": "다시 시도"
    },
    "completing": {
      "title": "인증 완료 중",
      "description": "로그인하는 동안 잠시 기다려 주세요..."
    },
    "errors": {
      "authenticationFailed": "인증 실패",
      "noAuthorizationCode": "OAuth 제공자로부터 인증 코드를 받지 못했습니다",
      "invalidServerResponse": "서버로부터 잘못된 응답",
      "unexpectedError": "인증 중 예상치 못한 오류가 발생했습니다",
      "noAdditionalDetails": "추가 세부 정보가 없습니다"
    }
  },
  "resetPassword": {
    "validation": {
      "minLength": "비밀번호는 최소 8자 이상이어야 합니다",
      "uppercase": "비밀번호는 최소 하나의 대문자를 포함해야 합니다",
      "lowercase": "비밀번호는 최소 하나의 소문자를 포함해야 합니다",
      "number": "비밀번호는 최소 하나의 숫자를 포함해야 합니다",
      "specialChar": "비밀번호는 최소 하나의 특수문자를 포함해야 합니다"
    },
    "errors": {
      "invalidToken": "유효하지 않은 토큰",
      "invalidTokenDescription": "이 비밀번호 재설정 링크는 유효하지 않거나 만료되었습니다.",
      "validationFailed": "검증 실패",
      "validationFailedDescription": "재설정 토큰 검증에 실패했습니다. 다시 시도해 주세요.",
      "fillAllFields": "모든 필드를 입력해 주세요",
      "passwordsDoNotMatch": "비밀번호가 일치하지 않습니다",
      "requirementsNotMet": "비밀번호 요구사항이 충족되지 않았습니다",
      "resetFailed": "비밀번호 재설정에 실패했습니다",
      "resetFailedTitle": "재설정 실패"
    },
    "success": {
      "title": "비밀번호 재설정 성공",
      "description": "비밀번호가 성공적으로 업데이트되었습니다.",
      "passwordUpdated": "✓ 비밀번호 업데이트됨",
      "securityNote": "이제 새 비밀번호로 로그인할 수 있습니다. 보안을 위해 모든 기기에서 로그아웃되었습니다.",
      "continueToLogin": "로그인으로 계속"
    },
    "validating": {
      "title": "재설정 링크 검증 중",
      "description": "비밀번호 재설정 링크를 검증하는 동안 잠시 기다려 주세요..."
    },
    "invalid": {
      "title": "유효하지 않은 재설정 링크",
      "description": "이 비밀번호 재설정 링크는 유효하지 않거나 만료되었습니다.",
      "linkInvalid": "링크 유효하지 않음",
      "reason1": "• 재설정 링크가 만료되었을 수 있습니다 (링크는 1시간 후 만료됩니다)",
      "reason2": "• 링크가 이미 사용되었을 수 있습니다",
      "reason3": "• 링크가 잘못되었거나 불완전할 수 있습니다",
      "requestNewLink": "새 재설정 링크 요청",
      "backToLogin": "로그인으로 돌아가기"
    },
    "form": {
      "title": "비밀번호 재설정",
      "description": "{{email}}의 새 비밀번호를 입력하세요",
      "newPassword": "새 비밀번호",
      "newPasswordPlaceholder": "새 비밀번호를 입력하세요",
      "confirmPassword": "새 비밀번호 확인",
      "confirmPasswordPlaceholder": "새 비밀번호를 확인하세요",
      "updating": "비밀번호 업데이트 중...",
      "updateButton": "비밀번호 업데이트",
      "backToLogin": "로그인으로 돌아가기"
    },
    "requirements": {
      "title": "비밀번호 요구사항",
      "minLength": "• 최소 8자 이상",
      "caseLetters": "• 대문자와 소문자 포함",
      "number": "• 최소 하나의 숫자 포함",
      "specialChar": "• 최소 하나의 특수문자 포함 (!@#$%^&*(),.?\":{}|<>)"
    },
    "expiration": {
      "notice": "이 재설정 링크는 {{time}}에 만료됩니다"
    }
  },
  "twoFAResetRequest": {
    "securityQuestions": {
      "question1": "마지막으로 성공한 거래는 언제였나요?",
      "question2": "현재 어떤 등급에 있나요 (1, 2, 또는 3)?",
      "question3": "주로 어떤 거래소를 사용하나요?"
    },
    "errors": {
      "fillRequiredFields": "모든 필수 필드를 입력해 주세요 (이메일, 전체 이름, 사유)",
      "submitFailed": "2FA 재설정 요청 전송 실패",
      "requestFailed": "요청 실패"
    },
    "success": {
      "requestSubmitted": "요청 전송됨",
      "title": "요청 전송됨",
      "description": "2FA 재설정 요청이 검토를 위해 제출되었습니다.",
      "submittedSuccessfully": "✓ 요청이 성공적으로 전송됨",
      "email": "이메일",
      "requestId": "요청 ID",
      "status": "상태",
      "pendingReview": "검토 대기 중",
      "whatHappensNext": "다음에 무엇이 일어나나요?",
      "step1": "1. 보안팀이 요청과 확인 정보를 검토합니다",
      "step2": "2. 필요시 추가 확인을 위해 연락드릴 수 있습니다",
      "step3": "3. 처리 완료 시 이메일 알림을 받게 됩니다",
      "step4": "4. 승인되면 2FA가 비활성화되고 다시 설정할 수 있습니다",
      "backToLogin": "로그인으로 돌아가기",
      "submitAnother": "다른 요청 제출"
    },
    "form": {
      "title": "2FA 재설정 요청",
      "description": "2FA 기기에 대한 액세스를 잃었나요? 보안팀에 재설정을 요청하려면 이 양식을 작성하세요.",
      "securityNotice": "⚠️ 중요한 보안 공지",
      "notice1": "• 이 과정은 보안팀의 수동 검토가 필요합니다",
      "notice2": "• 확인을 빠르게 하기 위해 가능한 한 정확한 정보를 제공하세요",
      "notice3": "• 허위 정보는 요청 거부로 이어집니다",
      "notice4": "• 처리 시간: 1-3 영업일",
      "requiredInformation": "필수 정보",
      "emailAddress": "이메일 주소 *",
      "fullName": "전체 이름 *",
      "reason": "2FA 재설정 사유 *",
      "additionalVerification": "추가 확인 (선택사항이지만 권장)",
      "lastLoginDate": "대략적인 마지막 로그인 날짜",
      "accountCreationDate": "대략적인 계정 생성 날짜",
      "recentActivity": "최근 계정 활동",
      "securityQuestionsTitle": "보안 질문",
      "securityQuestionsDescription": "신원 확인을 위해 이 질문들에 답해주세요. 모르면 비워두세요.",
      "submittingRequest": "요청 전송 중...",
      "submitButton": "2FA 재설정 요청 제출",
      "backToLogin": "로그인으로 돌아가기",
      "rememberDevice": "2FA 기기를 기억하시나요?",
      "tryVerification": "2FA 인증 시도",
      "placeholders": {
        "email": "계정 이메일 주소를 입력하세요",
        "fullName": "등록된 전체 이름을 입력하세요",
        "reason": "2FA를 재설정해야 하는 이유를 설명하세요 (예: 휴대폰 분실, 기기 고장 등)",
        "lastLoginDate": "예: 2024년 12월 15일",
        "accountCreationDate": "예: 2024년 11월",
        "recentActivity": "최근 활동을 설명하세요 (거래, 등급 변경, 결제 등)",
        "yourAnswer": "답변"
      }
    }
  },
  "verify2FA": {
    "title": "2단계 인증",
    "description": "6자리 인증 코드가 이메일 주소로 전송되었습니다",
    "form": {
      "verificationCode": "인증 코드",
      "placeholder": "6자리 코드 입력",
      "verifying": "인증 중...",
      "verifyCode": "코드 인증"
    },
    "errors": {
      "sessionExpired": "세션 만료",
      "pleaseLoginAgain": "다시 로그인해 주세요.",
      "enterCode": "인증 코드를 입력해 주세요",
      "codeMustBe6Digits": "인증 코드는 6자리여야 합니다",
      "verificationFailed": "인증 실패",
      "verificationFailedTitle": "인증 실패",
      "invalidCode": "유효하지 않은 인증 코드",
      "failedToResendCode": "코드 재전송 실패",
      "failedToResendTitle": "재전송 실패"
    },
    "success": {
      "loginSuccessful": "로그인 성공",
      "welcomeBack": "다시 오신 것을 환영합니다!",
      "codeSent": "코드 전송됨",
      "codeSentDescription": "새로운 인증 코드가 이메일로 전송되었습니다."
    },
    "help": {
      "needHelp": "도움이 필요하신가요?",
      "sending": "전송 중...",
      "resendCode": "코드 재전송",
      "backToLogin": "로그인으로 돌아가기",
      "lostDevice": "2FA 기기를 분실하셨나요? 재설정 요청",
      "didntReceiveCode": "코드를 받지 못하셨나요? 스팸 폴더를 확인하거나",
      "resendIt": "재전송하세요",
      "byContinuing": "계속하면 다음에 동의하는 것입니다",
      "termsOfService": "서비스 약관",
      "privacyPolicy": "개인정보 처리방침"
    }
  },
  "forgotPassword": {
    "errors": {
      "emailRequired": "이메일 주소가 필요합니다",
      "sendFailed": "비밀번호 재설정 이메일 전송에 실패했습니다",
      "requestFailed": "요청 실패"
    },
    "success": {
      "emailSent": "재설정 이메일 전송됨",
      "title": "이메일을 확인하세요",
      "description": "이 이메일로 계정이 존재하면 비밀번호 재설정 링크를 받게 됩니다.",
      "emailSentTitle": "이메일 전송됨",
      "emailSentMessage": "계정이 존재하면 {{email}}로 비밀번호 재설정 링크를 보냈습니다.",
      "instruction1": "• 이메일이 보이지 않으면 스팸/정크 폴더를 확인하세요",
      "instruction2": "• 재설정 링크는 1시간 후에 만료됩니다",
      "instruction3": "• 필요하면 다른 재설정을 요청할 수 있습니다",
      "sendAnother": "다른 재설정 이메일 보내기",
      "backToLogin": "로그인으로 돌아가기"
    },
    "form": {
      "title": "비밀번호 찾기",
      "description": "이메일 주소를 입력하시면 비밀번호 재설정 링크를 보내드립니다.",
      "emailAddress": "이메일 주소",
      "placeholder": "이메일 주소를 입력하세요",
      "sending": "전송 중...",
      "sendResetLink": "재설정 링크 보내기",
      "backToLogin": "로그인으로 돌아가기",
      "noAccount": "계정이 없으신가요?",
      "signUp": "가입하기",
      "lost2FA": "2FA 기기에 대한 액세스를 잃었나요?",
      "request2FAReset": "2FA 재설정 요청"
    },
    "security": {
      "title": "보안 참고사항",
      "note1": "• 비밀번호 재설정은 일반 계정에서만 사용할 수 있습니다",
      "note2": "• Google OAuth 사용자는 \"Google로 로그인\"을 사용해야 합니다",
      "note3": "• 재설정 링크는 보안을 위해 1시간 후에 만료됩니다"
    }
  }
};
